import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.93 2.98C3.307 2.98 2 4.276 2 5.86c0 2.12 1.476 4.121 3.181 5.692A19.988 19.988 0 0 0 8 13.705a19.988 19.988 0 0 0 2.819-2.152C12.524 9.98 14 7.98 14 5.86c0-1.585-1.306-2.88-2.93-2.88-.928 0-1.753.423-2.29 1.085L8 5.024l-.78-.959a2.942 2.942 0 0 0-2.29-1.084ZM8 14.865l-.49.863h-.001l-.002-.002-.006-.003-.019-.01a7.205 7.205 0 0 1-.307-.182 21.988 21.988 0 0 1-3.357-2.528C2.025 11.348 0 8.847 0 5.86 0 3.17 2.212 1 4.93 1 6.09 1 7.158 1.396 8 2.057A4.956 4.956 0 0 1 11.07 1C13.788 1 16 3.17 16 5.86c0 2.987-2.024 5.488-3.819 7.142a21.994 21.994 0 0 1-3.663 2.71l-.019.01-.006.003-.002.002L8 14.864Zm0 0 .49.863L8 16l-.49-.273.49-.863Zm-.49-.863Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconToggleHeartOff16 = createIcon(IconComponent);